import axios from "axios";
import { LOGIN_CONSTANTS } from "@/constants";
import { isPCFunc } from "@/utils/predicates";

// 创建一个 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    // timeout: 50000, // 请求超时时间
});

service.defaults.headers.common["source"] = isPCFunc()
    ? LOGIN_CONSTANTS.PLATFORM_PC
    : LOGIN_CONSTANTS.PLATFORM_MOBILE_WEB;
service.defaults.headers.common["product"] = LOGIN_CONSTANTS.PRODUCT_TYPE_VIEMAO;

/**
 * 获取视频信息
 * @param url
 * @param videoSource 3-YouTube链接视频；8-tiktok; 10-twitter
 * @param action 1-预取； 2-通过下载器下载视频；3-音频下载；4-字幕下载; 5-通过工作台下载视频(暂时没有)。 2，3，4情况不取缓存。
 */
export function queryYtDlpVideoInfo(url, videoSource, captchaToken, captchaType, temp, action = 1) {
    const obj = {
        url,
        videoSource,
        action,
    };
    if (captchaToken && captchaType) {
        obj.captchaToken = captchaToken;
        obj.captchaType = captchaType;
    } else {
        obj.timestamp = temp.tempKey;
        obj.tempSecret = temp.tempSecret;
    }
    return service
        .post("/api/v1/video-download/yt-dlp-video-info", obj)
        .then(({ data }) => data)
        .catch((e) => e);
}
